import type { BoggleGameModeDefinition, BoggleGameModeId } from './types'
import { RACE_GAME_MODE, RACE_HARD_GAME_MODE } from './race/definition'
import { REBOOT_GAME_MODE } from './reboot/definition'
import { SPRINT_GAME_MODE } from './sprint/definition'

export const BOGGLE_PUBLIC_GAME_MODES = [
  RACE_GAME_MODE,
  REBOOT_GAME_MODE,
  SPRINT_GAME_MODE,
] as const

export const BOGGLE_GAME_MODE_REGISTRY: Record<BoggleGameModeId, BoggleGameModeDefinition> = {
  race: RACE_GAME_MODE,
  'race-hard': RACE_HARD_GAME_MODE,
  reboot: REBOOT_GAME_MODE,
  sprint: SPRINT_GAME_MODE,
}

export function getBoggleGameModeDefinition(gameModeId: BoggleGameModeId) {
  return BOGGLE_GAME_MODE_REGISTRY[gameModeId]
}

export function getBogglePublicGameModes() {
  return BOGGLE_PUBLIC_GAME_MODES
}

export function isBogglePublicGameModeParam(
  raw: string,
): raw is BoggleGameModeId {
  return BOGGLE_PUBLIC_GAME_MODES.some(mode => mode.id === raw)
}

export function getBoggleGameModeRunSettings(gameModeId: BoggleGameModeId) {
  return getBoggleGameModeDefinition(gameModeId).corePreset
}
